import { render } from "./ConfirmDeleteModal.vue?vue&type=template&id=29170d8a&scoped=true"
import script from "./ConfirmDeleteModal.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteModal.vue?vue&type=script&lang=js"

import "./ConfirmDeleteModal.vue?vue&type=style&index=0&id=29170d8a&scoped=true&lang=css"

import exportComponent from "C:\\mgtspl\\mgtspl\\MGTSPL_FE\\MGTSPL\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29170d8a"]])

export default __exports__